import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Done from '@material-ui/icons/Done';
import { withStyles, Typography } from '@material-ui/core';

const getText = ({ cottage, fixed, order, paymentMethod }) => {
  if (!paymentMethod && order.products) {
    if (fixed) {
      if (cottage.paid_until) {
        return (
          <FormattedMessage
            id="payment.doneCardFixedPaidUntil"
            defaultMessage="Done! We have received your payment and your ad has been renewed."
          />
        );
      }

      return (
        <FormattedMessage
          id="payment.doneCardFixed24h"
          defaultMessage="Done! We have received your payment and we will review your ad within 24 hours."
        />
      );
    }

    return (
      <FormattedMessage
        id="payment.doneCard"
        defaultMessage="Done! We have received your payment."
      />
    );
  }
  if (paymentMethod === 'invoice') {
    return (
      <FormattedMessage
        id="payment.doneInvoice"
        defaultMessage="Done! We have received your order and will send you an invoice within 24 hours."
      />
    );
  }

  // Commission
  if (cottage.paid_until) {
    return (
      <FormattedMessage
        id="payment.doneCommissionPaidUntil"
        defaultMessage="Done! Your ad is now renewed."
      />
    );
  }

  return (
    <FormattedMessage
      id="payment.doneCommission24h"
      defaultMessage="Done! We will review your ad, normally within 24 hours."
    />
  );
};

getText.propTypes = {
  cottage: PropTypes.shape({}).isRequired,
  fixed: PropTypes.bool,
  order: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  paymentMethod: PropTypes.string,
};

const styles = (theme) => ({
  message: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
});

const PaymentDone = ({ classes, cottage, order, paymentMethod }) => {
  const fixed = !!(order.products && order.products.find(({ id }) => id === 1));

  const receipt = (
    <FormattedMessage
      id="payment.clickHereToSeeReceipt"
      defaultMessage="{ClickHere} to see the receipt!"
      values={{
        ClickHere: (
          <Link to={`/orders/${order.id}`}>
            <FormattedMessage id="Click here" defaultMessage="Click here" />
          </Link>
        ),
      }}
    />
  );

  return (
    <div className={classes.message}>
      <Done style={{ fontSize: 36 }} />
      <Typography paragraph align="center" variant="subtitle1">
        {getText({
          cottage,
          fixed,
          order,
          paymentMethod,
        })}
      </Typography>
      {paymentMethod !== 'invoice' && !!order.id && (
        <Typography paragraph align="center" variant="subtitle1">
          {receipt}
        </Typography>
      )}
    </div>
  );
};

PaymentDone.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  cottage: PropTypes.shape({}).isRequired,
  order: PropTypes.shape({
    id: PropTypes.number,
    products: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  paymentMethod: PropTypes.string,
};

export default withStyles(styles)(PaymentDone);
